import { $tracing } from '../tracing';

export const SecurityComponentTrack = (
  scene: string,
  msg: string,
  error: any,
) => {
  try {
    $tracing.addEvent({
      t: 'Security Component Error',
      ext: {
        scene,
        msg,
        error,
      },
    });
  } catch (error) {
    /* empty */
  }
};
